export default {
  methods: {
    server_base_url() {
      return window.global_mycover.server_base_url;
    },
    app_title() {
      return window.global_mycover.app_title;
    },
    impressum_url() {
      return window.global_mycover.impressum_url;
    }
  }
}


